import * as types from 'modules/devices/actionTypes';
import type { Device, DeviceReduxEntity } from 'modules/devices/types';
import type { Action, PageContent } from 'modules/global/generic.types';
import { createEntityAdapter, createReducer, type EntitySlice } from 'utils/ReduxUtils';

type RawDevice = {
  links?: unknown;
  dealer?: { id?: string };
  user?: { id?: string };
  userDealers?: Array<{ id: string }>;
} & Partial<Omit<Device, 'dealer' | 'user' | 'userDealers'>>;

export const deviceAdapter = createEntityAdapter<DeviceReduxEntity>({ selectId: ({ id }) => id });

export const deviceCleaner = ({
  links: _links,
  dealer,
  user,
  userDealers,
  ...device
}: RawDevice): Partial<DeviceReduxEntity> => ({
  ...device,
  userId: device.userId ?? user?.id,
  dealerId: device.dealerId ?? dealer?.id,
  ...(userDealers ? { userDealerIds: userDealers.map(({ id: dealerId }) => dealerId) } : {}),
});

const addFromPage = (state: EntitySlice<DeviceReduxEntity>, { payload }: Action<PageContent<Device>>) =>
  deviceAdapter.addMany(state, payload!.content.map(deviceCleaner));

const addOne = (state: EntitySlice<DeviceReduxEntity>, { payload: device }: Action<Device>) => {
  const existing = state.entities[device!.id];
  const conserved = existing?.userDealerIds ? { userDealerIds: existing.userDealerIds } : {};
  return deviceAdapter.addOne(state, deviceCleaner({ ...device!, ...conserved }));
};

export default createReducer(deviceAdapter.getInitialState(), {
  [types.FETCH_DEVICES_SUCCESS]: addFromPage,
  [types.PATCH_DEVICE_SUCCESS]: addOne,
  [types.FETCH_DEVICE_SUCCESS]: addOne,
});
